import React from 'react';
import { WebsiteDesignProps } from './types';
import { Asterisk, ArrowDownRight } from 'lucide-react';

const EditorialStyle: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "The Daily School";

    return (
        <div className="bg-[#f5f5f5] text-black min-h-screen font-serif">
             <header className="px-6 py-6 border-b border-black flex justify-between items-start sticky top-0 bg-[#f5f5f5] z-50">
                 <div className="text-xs font-sans font-bold uppercase tracking-widest flex flex-col gap-1">
                     <span>Vol. 2026</span>
                     <span>Issue No. 04</span>
                     <span>London / NY</span>
                 </div>
                 <h1 className="text-5xl md:text-7xl font-light tracking-tighter leading-[0.8] text-center absolute left-1/2 -translate-x-1/2 top-4">
                     {schoolName}
                 </h1>
                 <div className="text-xs font-sans font-bold uppercase tracking-widest text-right flex flex-col gap-1">
                     <a href="#" className="hover:underline">Subscribe</a>
                     <a href="#" className="hover:underline">Contact</a>
                     <a href="#" className="hover:underline">Login</a>
                 </div>
             </header>

             <main className="container mx-auto px-6 py-12">
                 <div className="grid grid-cols-12 gap-6 items-start">
                     {/* Big Headline */}
                     <div className="col-span-12 mb-12 text-center">
                         <h2 className="text-8xl md:text-9xl italic font-light hover:italic transition-all cursor-pointer">
                             Intellect <span className="font-sans not-italic font-bold text-4xl align-middle mx-4 bg-black text-white px-4 py-2 rounded-full">&&</span> Instinct
                         </h2>
                     </div>

                     {/* Image Column */}
                     <div className="col-span-12 md:col-span-5 relative">
                         <div className="aspect-[3/4] overflow-hidden">
                             <img src="https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover filter contrast-125" alt="Fashion" />
                         </div>
                         <div className="absolute top-4 left-4 bg-white px-2 py-1 text-xs font-sans font-bold border border-black transform -rotate-2">
                             FEATURED STORY
                         </div>
                     </div>

                     {/* Text Column */}
                     <div className="col-span-12 md:col-span-7 flex flex-col gap-12 pt-12 pl-0 md:pl-12">
                         <div className="border-t border-black pt-4">
                             <div className="flex justify-between items-center mb-4">
                                 <span className="font-sans font-bold text-xs uppercase">01 — The Vision</span>
                                 <Asterisk size={16} />
                             </div>
                             <p className="text-3xl leading-snug font-light">
                                 "We are redefining the educational landscape by merging classical theory with avant-garde practice. The result is nothing short of revolutionary."
                             </p>
                         </div>

                         <div className="grid grid-cols-2 gap-8 border-t border-black pt-4">
                             <div>
                                 <span className="font-sans font-bold text-xs uppercase block mb-4">02 — Admissions</span>
                                 <p className="text-sm font-sans leading-relaxed text-gray-600">
                                     Our selection process is rigorous, looking for the spark of creativity that cannot be taught. Applications open seasonally.
                                 </p>
                                 <a href="#" className="inline-block mt-4 border-b border-black pb-0.5 text-xs font-sans font-bold uppercase hover:bg-black hover:text-white transition-colors">Apply</a>
                             </div>
                             <div>
                                 <span className="font-sans font-bold text-xs uppercase block mb-4">03 — Campus</span>
                                 <p className="text-sm font-sans leading-relaxed text-gray-600">
                                     Located in the heart of the cultural district, our campus is a living canvas for student expression and community engagement.
                                 </p>
                                 <a href="#" className="inline-block mt-4 border-b border-black pb-0.5 text-xs font-sans font-bold uppercase hover:bg-black hover:text-white transition-colors">Visit</a>
                             </div>
                         </div>
                         
                         <div className="bg-[#ff4000] text-white p-8 text-center mt-8 rounded-tr-[40px]">
                              <p className="font-sans font-bold text-lg mb-4">Open Day: Oct 24th</p>
                              <ArrowDownRight size={48} className="mx-auto" />
                         </div>
                     </div>
                 </div>
             </main>
        </div>
    );
};

export default EditorialStyle;
